const FAQS = [
  {
    q: '虫虫漫画网真的完全免费吗？',
    a: '是的！虫虫漫画网所有漫画内容均免费提供，无需付费即可畅享海量韩漫、日漫、国漫资源。我们通过广告收入维持平台运营，不会向读者收取任何阅读费用。',
  },
  {
    q: '什么是下拉式阅读模式？',
    a: '下拉式阅读是虫虫漫画网的核心特色功能。与传统的翻页模式不同，您只需向下滑动屏幕即可连续阅读整部漫画，无需点击翻页按钮，带来更流畅、沉浸式的阅读体验，尤其适合手机端用户。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '平台每日同步更新热门连载漫画，确保读者第一时间看到最新章节。热门韩漫、日漫、国漫通常每周更新1-2话，部分高人气作品可实现日更。您可以通过收藏功能订阅喜欢的作品，更新时第一时间收到通知。',
  },
  {
    q: '支持哪些设备阅读？',
    a: '虫虫漫画网支持PC端网页、手机浏览器、以及iOS和Android APP。所有设备均适配下拉式阅读模式，阅读进度自动云端同步，换设备也能无缝衔接阅读。推荐下载APP获得最佳阅读体验。',
  },
  {
    q: '如何找到好看的漫画推荐？',
    a: '您可以通过首页热门推荐、排行榜、话题标签等多种方式发现好看的漫画。平台智能推荐系统会根据您的阅读历史推荐可能感兴趣的作品。此外，热门话题区域实时展示当下最火的漫画类型和作品。',
  },
  {
    q: '可以离线下载漫画吗？',
    a: '可以！下载虫虫漫画网APP后，您可以将喜欢的漫画章节离线下载到本地，在没有网络的情况下也能随时随地阅读。离线下载功能完全免费，不限下载数量，让阅读不受网络限制。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            关于<strong>免费看漫画</strong>的常见疑问，这里都有答案
          </p>
        </div>
        <div className="max-w-3xl mx-auto grid gap-4">
          {FAQS.map((faq) => (
            <div
              key={faq.q}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 font-heading mb-3 flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-sm font-bold shrink-0 mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed pl-9">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}